<script lang="ts">
import Sparkle from "~icons/ph/sparkle-duotone"
let {
  class: className = "",
  ...props
} = $props()
</script>
<Sparkle class="{className} [&_path]:fill-warning [&_path[opacity]]:fill-yellow-300 [&_path[opacity]]:opacity-100" {...props} />